import React from "react";
import ReactDOM from "react-dom";
import en from "react-intl/locale-data/en";
import es from "react-intl/locale-data/es";
import { IntlProvider, addLocaleData } from "react-intl";
import { getLanguageFromUrl } from "./app/AppHelpers";
import messages_en from "./translations/en.json";
import messages_es from "./translations/es.json";
import App from "./app/App";

addLocaleData([...en, ...es]);

const messages = {
  en: messages_en,
  es: messages_es
};

const language = getLanguageFromUrl();

ReactDOM.render(
  <IntlProvider locale={language} messages={messages[language]}>
    <App />
  </IntlProvider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js